import { useState } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import ModuleShell from "@/components/ModuleShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { FileText } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function InterventionReportModule() {
  useDocumentTitle("Modulo · Verbale Intervento");
  const [oggetto, setOggetto] = useState("");
  const [verbale, setVerbale] = useState("");

  return (
    <ModuleShell
      title="Verbale Intervento"
      subtitle="Descrizione libera di un intervento eseguito"
      icon={FileText}
      endpoint="/modules/intervention-report/pdf"
      filenamePrefix="verbale-intervento"
      emailSubject={() => "Verbale Intervento - Diotech"}
      emailBody={(c) => `Gentile ${c.surname} ${c.name},\n\nin allegato trova il verbale dell'intervento effettuato.`}
      validate={() => {
        if (!oggetto.trim()) return "Oggetto richiesto";
        return null;
      }}
      buildPayload={(customerId) => ({
        customer_id: customerId,
        oggetto: oggetto.trim(),
        verbale: verbale,
      })}
    >
      <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mb-3">// DATI VERBALE</div>
      <div className="space-y-4">
        <div>
          <Label className="font-mono text-[10px] uppercase tracking-widest">Oggetto *</Label>
          <Input value={oggetto} onChange={(e) => setOggetto(e.target.value)} placeholder="Es. Sostituzione SSD e configurazione backup" className="mt-1.5" data-testid="report-oggetto-input" />
        </div>
        <div>
          <Label className="font-mono text-[10px] uppercase tracking-widest">Verbale / descrizione intervento</Label>
          <Textarea
            rows={12}
            value={verbale}
            onChange={(e) => setVerbale(e.target.value)}
            placeholder={"Descrivi cronologicamente cosa hai fatto, materiali usati, osservazioni tecniche, raccomandazioni al cliente…"}
            className="mt-1.5"
            data-testid="report-verbale-input"
          />
          <div className="text-[10px] text-muted-foreground mt-1 font-mono">
            Il testo va a capo automaticamente e supporta più pagine PDF.
          </div>
        </div>
      </div>
    </ModuleShell>
  );
}
